angular.module('angus.controllers').controller('usersReportController', [
    '$rootScope', '$scope', 'windowsService',
    function ($rootScope, $scope, windowsService) {

    }
])